import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/http';
import { useLocale } from '@/app/[lang]/providers/LocaleProvider';
import { HomePage } from '../type/type';

export const homePageQueryKey = (lang: string) => ['home-page', lang];

export function useHomePage() {
  const lang = useLocale();
  return useQuery<HomePage>({
    queryKey: homePageQueryKey(lang),
    enabled: true,
    queryFn: async () => {
      const res = await http.get(`/api/home-pages/1?lang=${lang}`);
      return res.data.data;
    },
  });
}
